import { render, staticRenderFns } from "./CollectionBackPerformance.vue?vue&type=template&id=2199bab1&scoped=true"
import script from "./CollectionBackPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionBackPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionBackPerformance.vue?vue&type=style&index=0&id=2199bab1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199bab1",
  null
  
)

export default component.exports